import * as tel from '../constants/phones'

export const actionTypes = {
	SET_PANEL_FAVS: 'header/SET_PANEL_FAVS',
	SET_PANEL_PROFILE: 'header/SET_PANEL_PROFILE',
	SET_MODAL_HEADER: 'header/SET_MODAL_HEADER',
	SHOW_DETAILS: 'header/SHOW_DETAILS',
	SET_PHONE: 'header/SET_PHONE'
}

export const setPanelFavs = () => {
	return {
		type: actionTypes.SET_PANEL_FAVS
	}
}

export const setPanelProfile = () => {
	return {
		type: actionTypes.SET_PANEL_PROFILE
	}
}

export const setModalStatus = () => {
	return {
		type: actionTypes.SET_MODAL_HEADER
	}
}

export const showDetails = () => {
	return {
		type: actionTypes.SHOW_DETAILS
	}
}

export const setPhone = (val) => {
	let value = val.replace(/(\d{4})(\d{4})/, '$1-$2')

	if ((val == 'puertos') || (val == 'Puertos')) {
		value = tel.TEL_PUERTOS
	}
	else if ((val == 'nordelta') || (val == 'Nordelta')) {
		value = tel.TEL_NORDELTA
	}
	else if ((val == 'recoleta') || (val == 'Recoleta')) {
		value = tel.TEL_RESIDENTIAL
	}
	else if ((val == 'Lomas de San Isidro') || (val == 'sanisidro')) {
		value = tel.TEL_SANISIDRO
	}
	else if ((val == 'Palermo') || (val == 'palermo')) {
		value = tel.TEL_PALERMO
	}
  else if ((val == 'pilar') || (val == 'Pilar')) {
		value = tel.TEL_PILAR
	}
  else if ((val == 'escobar') || (val == 'Escobar')) {
    value = tel.TEL_ESCOBAR
  }

	return {
		type: actionTypes.SET_PHONE,
		value
	}
}



// WEBPACK FOOTER //
// ./src/actions/header.js